/**
 * `AW1` · La configuración de la instancia, disponible para el árbol.
 *
 * Existe para que `tabla.tsx` pueda leer `pageSize` y `refrescoMs` sin recibir
 * plomería por props a través de cada componente intermedio. Se resuelve UNA vez
 * al arrancar (`main.tsx`) y no cambia mientras la pestaña vive: no hay estado
 * acá, sólo un valor ya leído.
 */

import { createContext, useContext } from "react"
import type { ConfiguracionInstancia } from "./configuracion.ts"

/**
 * Sin valor por defecto, a propósito.
 *
 * Un default —aunque fuera `pageSize: 10`— haría que un componente montado
 * fuera del proveedor anduviera igual, con valores que nadie configuró. Falla
 * fuerte y en el primer render en vez de servir datos de una instancia
 * imaginaria.
 */
const ContextoConfiguracion = createContext<ConfiguracionInstancia | null>(null)

export const ProveedorConfiguracion = ContextoConfiguracion.Provider

export function useConfiguracion(): ConfiguracionInstancia {
  const config = useContext(ContextoConfiguracion)
  if (config === null) {
    throw new Error(
      "useConfiguracion() se llamó fuera de <ProveedorConfiguracion>. La configuración se carga en main.tsx antes de montar la aplicación.",
    )
  }
  return config
}
